/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="m6.7545 12.8452 1.0064-2.6631 1.0107 2.6631h-2.017ZM14.4449 12.2827h-1.6347v-2.1621h1.6919c.2944 0 .5361.1099.7295.3252.1933.2153.29.4658.29.7515 0 .2856-.1011.5361-.3032.7514-.2022.2154-.4614.3252-.7822.3252l.0087.0088Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.0009 24c6.6274 0 12-5.3726 12-12s-5.3726-12-12-12c-6.6275 0-12 5.3726-12 12s5.3725 12 12 12Zm-2.302-8.6982h1.2876L8.5651 9H6.961l-2.4126 6.3018h1.2788l.523-1.3667h2.8344l.5142 1.3667ZM14.546 9h-2.9531v6.3018h1.2261V13.377h1.6743c.6811 0 1.2261-.2198 1.6304-.6592.4043-.4395.6064-.9492.6064-1.5249 0-.5625-.2021-1.0679-.6064-1.5161-.4043-.4483-.9317-.6724-1.5865-.6724L14.546 9Zm3.2025 6.3018h1.2524V9h-1.2524v6.3018Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuAPIDefinitionFilled'
);
